export default "__VITE_ASSET__c5602d34__"